import { Vector3 } from 'three'
import { useFrame } from '@react-three/fiber'
import { ThreeCamera } from '../../../classes/three'
import { useEffect } from 'react'
import { useMontage } from '../../../context/montage.context'
import { selectGroups, useGroups } from '@k3/core'


export const state = {
  cameraPosition: ThreeCamera.cameraPositions.maße,
  currentPosition: ThreeCamera.cameraPositions.maße,
  update: true,
}

export const stateEgo = {
  cameraEgoPosition: ThreeCamera.cameraEgoPositions.ego,
  currentEgoPosition: ThreeCamera.cameraEgoPositions.ego,
  update: true,
}

export const CameraControls = (): null => {
const { measure, ego, roof} = useMontage()

  useEffect(()=> {

    window.addEventListener('click', (event: unknown) => {
      const mont:string = roof.attachment
      if (ego?.ego) {
        const cameraEgoPosition = ThreeCamera.cameraEgoPostion(
          event as { target: HTMLDivElement }, measure, mont
        )     
        if (cameraEgoPosition) { 
          stateEgo.cameraEgoPosition = cameraEgoPosition
          stateEgo.update = true
        }
      } else {
        const cameraPosition = ThreeCamera.cameraPostion(
          event as { target: HTMLDivElement }, measure, mont
        )
        if (cameraPosition) {
         
          state.cameraPosition = cameraPosition
          state.update = true
        }
      }
    })
  }, [ego?.ego, measure, roof.attachment])
 
  useFrame(({ camera, scene }) => {
    if (state.update && !ego?.ego) {
      camera.position.lerp(new Vector3(...state.cameraPosition), 0.1)
      //@ts-ignore
      scene.orbitControls.update()
      const distance = +camera.position
        .clone()
        .sub(new Vector3(...state.cameraPosition))
        .length()

      if (distance < 0.05) state.update = false
      return null
    } else if (stateEgo.update && ego?.ego) {
      camera.position.lerp(new Vector3(...stateEgo.cameraEgoPosition), 0.1)
      //@ts-ignore
      scene.orbitControls.update()
      const distance = +camera.position
        .clone()
        .sub(new Vector3(...stateEgo.cameraEgoPosition))
        .length()
      if (distance < 0.001) stateEgo.update = false

      return null
    }
  })

  return null
}
